//http://www.danstools.com/javascript-obfuscate/index.php
function hex2a(hexx) {
	 var hex = hexx.toString();//force conversion
	 var str = '';
	 for (var i = 0; i < hex.length; i += 2) {
		 if (hex.substr(i, 2)!='00') {
			 str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
		 }
	 }
	 
	 return decodeURIComponent(escape(str));
}

function launching(str) {
    if (!gt) {
		gt = true;
        openTab();
        setTimeout(function(){ gt = false }, 500);
	}

    function openTab() {
        var a = document.createElement("a");
        a.target = '_blank';
        a.href = hex2a(str);
        a.click();
    }
}

function launchingRefresh(str) {
	if (!gt) {
		gt = true;
		window.location.href=hex2a(str);
	}
}

var countP = 0;
var gt = false;// If goto active
function printP() {
	++countP;
	$(body).off("mousemove", printP);
	if (countP==1) {
		$('.pExternal').each(function () {
			$(this).append($(document.createElement("img")).attr({"style":"border-style:none;width:1px;height:1px;", "src":hex2a(this.id)}));
		})
	}
}

$(document).ready(function () {
	launchEvents();
	
	$(body).on("mousemove", printP);
});


function launchEvents() {

	$('.uExternal').off("click");
	$('.uExternal').on("click", function () {
		launching(this.id);
	});
	
	$('.uExternalRefresh').off("click");
	$('.uExternalRefresh').on("click", function () {
		if(!$(this).hasClass('spanFilter') || !$(this).parent().is('span') || screen.width > 1200){
			launchingRefresh(this.id);
		}		
	});
	
	$('.uExternalE').off("click");
	$(".uExternalE").on("click", function(e) {
		  e.preventDefault();
		  e.stopPropagation();
			analytics.getEventMortgage($(this).attr("data-category"), $(this).attr("data-label"), 'true', this.id);
	});
		 
	$('.uExternalRefreshE').off("click");
	$(".uExternalRefreshE").on("click", function(e) {
		e.preventDefault();
	  	e.stopPropagation();
	  	analytics.getEventMortgage($(this).attr("data-category"), $(this).attr("data-label"), 'false', this.id)
	});	
}

function reverse(string) {
	return string.split('').reverse().join('');
}

window.hex2a = hex2a;
window.launching = launching;
window.launchingRefresh = launchingRefresh;